import {Dispatch, SetStateAction} from "react";
import Form from 'react-bootstrap/Form';
import {useTranslation} from "react-i18next";

interface RowsPerPageProps {
    rowsPerPage : number
    setRowsPerPage?: Dispatch<SetStateAction<number>>
    setCurrentPage?: Dispatch<SetStateAction<number>>
    maxRowsPerPage?: number
}

export const RowsPerPage = ({rowsPerPage, setRowsPerPage, setCurrentPage, maxRowsPerPage = 160} : RowsPerPageProps) =>
{
    /**
     * i18next translation hook
     */
    const {t} = useTranslation();

    const onChangeRowsPerPage = (newRowsPerPage : number) =>
    {
        if (setRowsPerPage !== undefined) {
            setRowsPerPage(newRowsPerPage);
        }

        // reset the current page because the old page might not exist
        if (setCurrentPage !== undefined) {
            setCurrentPage(1);
        }
    }


    const addOption = (rowsPerPage : number, addText : boolean)=>
    {
        return (
            rowsPerPage <= maxRowsPerPage &&
            <option value={rowsPerPage}>{rowsPerPage} {addText && t("pager.rows-per-page")}</option>
        )
    }

    return (
        <>
            <Form.Select className="d-none d-lg-block" value={rowsPerPage}
                         onChange={(e) => onChangeRowsPerPage(Number(e.target.value))}>
                {addOption(5, true)}
                {addOption(10, true)}
                {addOption(20, true)}
                {addOption(40, true)}
                {addOption(80, true)}
                {addOption(160, true)}
            </Form.Select>

            <Form.Select className="d-lg-none" value={rowsPerPage}
                         onChange={(e) => onChangeRowsPerPage(Number(e.target.value))}>
                {addOption(5, false)}
                {addOption(10, false)}
                {addOption(20, false)}
                {addOption(40, false)}
                {addOption(80, false)}
                {addOption(160, false)}
            </Form.Select>
        </>
    )
}
